export default "__VITE_ASSET__w_MVTf00LzUtBfx4jokTTg__"